import { Text } from '@fluentui/react';
import React from 'react';
import { Trans } from 'react-i18next';
import { normalizeConfidentialIdentifiers } from 'app/modules/newTicketView/confidentialIdentifiers';
import DetailCard from './DetailCard';

interface IProps {
    value?: string;
    isVisible?: boolean;
}

const ConfidentialIdentifier = ({ value, isVisible = true }: IProps) => {
    const confidentialIdentifier = normalizeConfidentialIdentifiers(value);

    if (!isVisible || !confidentialIdentifier) {
        return null;
    }

    return (
        <DetailCard title={<Trans>Confidential Identifier</Trans>}>
            <div
                className="dp-content-text"
                data-testid="confidential-identifier-value"
                style={{ whiteSpace: 'pre-line' }}>
                <Text>{confidentialIdentifier}</Text>
            </div>
        </DetailCard>
    );
};

export default ConfidentialIdentifier;
